export default function(source, keys) {
  return Array.from(keys, key => source[key]);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-array/src/permute.js
// module id = 1465
// module chunks = 0